module.exports = __webpack_public_path__ + "static/img/feature02.98fe8342.png";